<template>
	<div>
		<div class="centerBtn">
			<div class="block">
				费率
				<el-input-number size="medium" v-model="num" controls-position="right" :precision="2" :step="0.01" style="margin: 0px 10px;"></el-input-number>
				角/分钟
				<el-button size="medium" type="primary" style="margin-left: 10px;"  @click="recalculate">重新计算</el-button>
			</div>
		</div>
		<div class="botTable">
			<el-table :data="tableData" border style="width: 100%; margin-top: 20px">
				<el-table-column prop="userName" label="姓名" align="center" width="180"></el-table-column>
				<el-table-column prop="totalTime" label="拨打总时长(分钟)" align="center"></el-table-column>
				<el-table-column prop="validTime" label="有效时长(分钟)" align="center"></el-table-column>
				<el-table-column label="成功率" align="center">
					<template slot-scope="scope">
						{{ scope.row.successPercent }}%
					</template>
				</el-table-column>
				<el-table-column label="预估费用(元)" align="center">
					<template slot-scope="scope">
						¥ {{ scope.row.budgetCost }}
					</template>
				</el-table-column>
				<el-table-column label="预估有效费用(元)" align="center">
					<template slot-scope="scope">
						¥ {{ scope.row.budgeValidtCost }}
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pagination.currentPage"
					:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
					:page-size="pagination.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		surveyId: {
			type: String
		},
		source: {
			type: String
		}
	},
	data() {
		return {
			num: 0.06,
			timeParams: {
				name: '',
				beginTime: '',
				endTime: ''
			},
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			tableData: []
		};
	},
	created() {
		this.queryRateData();
	},
	methods: {
		// modifyRate
		recalculate() {
			let data = {
				surveyId: this.surveyId,
				source: this.source,
				rate: this.num //	费率 0.06角/分钟
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.modifyRate}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						// that.num = res.resultBody;
						that.loadData();
					} else {
						that.loadData();
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// queryRate
		queryRateData() {
			let data = {
				surveyId: this.surveyId
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryRate}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.num = res.resultBody;
						that.loadData();
					} else {
						that.loadData();
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadData() {
			let data = {
				userName: this.timeParams.name,
				beginTime: this.timeParams.beginTime,
				endExamTime: this.timeParams.endTime,
				currentPage: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				source: this.source,
				surveyId: this.surveyId,
				rate: this.num //	费率 0.06角/分钟
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.telephoneChargeTJ}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pagination.currentPage = val;
			this.loadData();
		}
	}
};
</script>

<style scoped lang="scss">
.centerBtn {
	display: flex;
	justify-content: right;
	.block {
		display: flex;
		align-items: center;
		font-size: 14px;
	}
}
.botTable {
	.block {
		text-align: right;
		margin-top: 20px;
	}
}
</style>
